import { FlightShopActions, type FlightState } from "@b2bportal/core-flights";
import {
  type PackageFlightTripDetailRequest,
  type PackageFlightTripDetailResponse,
  packagesApi,
} from "@b2bportal/packages-api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchPackageFlightsTripDetail = createAsyncThunk<
  PackageFlightTripDetailResponse,
  { searchToken: string; tripId: string },
  { state: FlightState; rejectValue: { error: string } }
>(
  "packages/fetchFlightsTripDetail",
  async ({ searchToken, tripId }, thunkAPI) => {
    try {
      const requestBody: PackageFlightTripDetailRequest = {
        opaquePackageToken: {
          value: searchToken,
        },
        tripId,
      };

      const res =
        await packagesApi(axios).apiV0PackagesFlightsTripDetailPost(
          requestBody
        );

      const data = res.data;

      thunkAPI.dispatch(
        FlightShopActions.setFetchTripDetails(data.response.value)
      );

      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: String(error) });
    }
  }
);
